var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"jrm-embm-u-adds-unit"},[(_vm.ingredient.image)?_c('img',{attrs:{"src":_vm.$generateAssetsUrl(_vm.ingredient.image),"alt":_vm.ingredient.name}}):_c('DefaultImage')],1)}
var staticRenderFns = []

export { render, staticRenderFns }